export const arrows = {
  '& .arrows': {
    float: 'right',
    '& .fa-arrow-up, & .fa-arrow-down': {
      'border-radius': '4px',
      padding: '.25em',
      margin: '0 .5em 0 0',
      border: '1px solid #1d71ad',
      color: '#1d71ad',
      height: '28px',
      width: '28px',
    },
  },
};
